import { fmtChips } from "../helpers";

export function ChopPoolsView({ chops, playerByUid }) {
  if (!chops?.length) return null;
  const groups = {};
  chops.forEach((c) => {
    const key = `${c.stage ?? "?"}-${c.pool_id ?? 0}`;
    if (!groups[key]) groups[key] = { stage: c.stage, pool_id: c.pool_id, users: [] };
    groups[key].users.push(c);
  });
  return (
    <section className="border-t border-white/10 px-3 py-3 bg-amber-900/10" data-testid="chop-pools-view">
      <h4 className="text-[11px] uppercase tracking-wider font-semibold text-amber-300 mb-2">
        EV Chop ({chops.length} votos)
      </h4>
      {Object.values(groups).map((g) => (
        <div key={`${g.stage}-${g.pool_id}`} className="mb-2">
          <div className="text-[10px] text-slate-400 mb-1">Stage {g.stage} · Pool {g.pool_id}</div>
          <table className="w-full text-[12px] text-slate-300">
            <thead className="text-slate-500">
              <tr><th className="text-left">Jugador</th><th className="text-right">WinRate</th><th className="text-right">Chips</th><th className="text-right">Voto</th></tr>
            </thead>
            <tbody>
              {g.users.map((u, i) => (
                <tr key={i}>
                  <td className="truncate">{u.nick || `uid:${u.uid}`}</td>
                  <td className="text-right tabular-nums">{u.win_rate}%</td>
                  <td className="text-right tabular-nums">{fmtChips(u.chips_chips)}</td>
                  <td className="text-right">{u.choice_type === 1 ? "Chop" : u.choice_type === 0 ? "Run" : `?${u.choice_type}`}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ))}
    </section>
  );
}
